// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1igJz","option":"styles_option__K5ADU","selected":"styles_selected__2i_im"};